/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var SOLD_COUNTER_ENABLED = false;

  if (!SOLD_COUNTER_ENABLED) {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-sold-today]').forEach(function (el) {
        el.style.display = 'none';
      });
    });
    return;
  }

  var SOLD_ATTRIBUTE = 'data-sold-today';
  var STORAGE_PREFIX = 'mth_inventory_baseline_';
  var SOLD_SUFFIX_DEFAULT = ' SOLD TODAY!';
  var MIN_SOLD_DISPLAY = 1;
  var inventoryCache = {};

  function todayStamp() {
    var now = new Date();
    var month = now.getMonth() + 1;
    var day = now.getDate();
    var paddedMonth = month < 10 ? '0' + month : String(month);
    var paddedDay = day < 10 ? '0' + day : String(day);
    return now.getFullYear() + '-' + paddedMonth + '-' + paddedDay;
  }

  function storageKey(productId) {
    return STORAGE_PREFIX + productId + '_' + todayStamp();
  }

  function readBaseline(productId) {
    var key = storageKey(productId);
    var fallback = { date: todayStamp(), variants: {} };

    try {
      var raw = window.localStorage.getItem(key);

      if (!raw) {
        return fallback;
      }

      var parsed = JSON.parse(raw);

      if (!parsed || parsed.date !== fallback.date) {
        return fallback;
      }

      parsed.variants = parsed.variants || {};
      return parsed;
    } catch (error) {
      return fallback;
    }
  }

  function writeBaseline(productId, record) {
    try {
      window.localStorage.setItem(storageKey(productId), JSON.stringify(record));
    } catch (error) {
      // Silently fail if storage is not available
    }
  }

  function ensureInventoryCache(scriptEl) {
    if (!scriptEl || !scriptEl.textContent) {
      return;
    }

    try {
      var data = JSON.parse(scriptEl.textContent);

      if (!data || !data.product || !data.product.id) {
        return;
      }

      var productId = data.product.id;

      if (!inventoryCache[productId]) {
        inventoryCache[productId] = {};
      }

      if (data.inventories) {
        Object.keys(data.inventories).forEach(function (variantId) {
          var entry = data.inventories[variantId];

          if (entry && typeof entry.inventory_quantity === 'number') {
            inventoryCache[productId][variantId] = entry.inventory_quantity;
          }
        });
      } else if (data.product.variants) {
        data.product.variants.forEach(function (variant) {
          if (variant && typeof variant.inventory_quantity === 'number') {
            inventoryCache[productId][variant.id] = variant.inventory_quantity;
          }
        });
      }
    } catch (error) {
      console.warn('Daily sales count: unable to parse product data JSON', error);
    }
  }

  function bootstrapInventoryCache(root) {
    var scope = root || document;
    scope.querySelectorAll('script[data-product-json]').forEach(ensureInventoryCache);
  }

  function lookupInventory(productId, variantId) {
    var variants = inventoryCache[productId];

    if (variants && variants.hasOwnProperty(String(variantId))) {
      return variants[String(variantId)];
    }

    return null;
  }

  function computeSold(productId, variantId, currentQty) {
    if (typeof currentQty !== 'number' || isNaN(currentQty)) {
      return null;
    }

    var baseline = readBaseline(productId);
    var stored = baseline.variants[String(variantId)];

    if (typeof stored !== 'number' || currentQty > stored) {
      stored = currentQty;
      baseline.variants[String(variantId)] = stored;
    }

    var sold = stored - currentQty;

    if (sold < 0) {
      sold = 0;
    }

    if (sold < MIN_SOLD_DISPLAY) {
      sold = MIN_SOLD_DISPLAY;
    }

    writeBaseline(productId, baseline);
    return sold;
  }

  function parseNumber(value) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  function updateElement(el, options) {
    options = options || {};

    var productId = options.productId || parseNumber(el.getAttribute('data-product-id'));
    var variantId = options.variantId || el.getAttribute('data-variant-id');
    var currentQty = options.currentQty;

    if (typeof currentQty !== 'number') {
      currentQty = parseNumber(el.getAttribute('data-current-qty'));
    }

    if (!productId || !variantId) {
      return;
    }

    if (typeof currentQty !== 'number' || isNaN(currentQty)) {
      var cachedQty = lookupInventory(productId, variantId);

      if (typeof cachedQty === 'number') {
        currentQty = cachedQty;
      }
    }

    if (typeof currentQty !== 'number') {
      return;
    }

    var sold = computeSold(productId, variantId, currentQty);

    if (sold === null) {
      return;
    }

    var suffix = el.getAttribute('data-sold-suffix') || SOLD_SUFFIX_DEFAULT;
    el.textContent = sold + suffix;
  }

  function refreshSoldCounts(root) {
    var scope = root || document;
    scope.querySelectorAll('[' + SOLD_ATTRIBUTE + ']').forEach(function (el) {
      updateElement(el);
    });
  }

  function handleVariantChange(event) {
    var variant = event.detail && event.detail.variant;

    if (!variant || typeof variant.id === 'undefined') {
      return;
    }

    var productId = variant.product_id || parseNumber(event.target.getAttribute('data-product-id'));

    if (!productId) {
      // Try grabbing product id from the closest sold message
      var soldEl = event.target.querySelector('[' + SOLD_ATTRIBUTE + ']');

      if (soldEl) {
        productId = parseNumber(soldEl.getAttribute('data-product-id'));
      }
    }

    if (!productId) {
      return;
    }

    if (typeof variant.inventory_quantity === 'number') {
      if (!inventoryCache[productId]) {
        inventoryCache[productId] = {};
      }

      inventoryCache[productId][String(variant.id)] = variant.inventory_quantity;
    }

    event.target.querySelectorAll('[' + SOLD_ATTRIBUTE + ']').forEach(function (el) {
      el.setAttribute('data-variant-id', variant.id);

      if (typeof variant.inventory_quantity === 'number') {
        el.setAttribute('data-current-qty', variant.inventory_quantity);
        updateElement(el, {
          productId: productId,
          variantId: variant.id,
          currentQty: variant.inventory_quantity
        });
      } else {
        updateElement(el, {
          productId: productId,
          variantId: variant.id
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bootstrapInventoryCache();
    refreshSoldCounts();
  });

  document.addEventListener('shopify:section:load', function (event) {
    bootstrapInventoryCache(event.target);
    refreshSoldCounts(event.target);
  });

  document.addEventListener('variant:changed', handleVariantChange);
})();
